module.exports = __webpack_public_path__ + "media/images/badges/bft/milestone-250-inactive-bft-9deb206b256e326825759f0dccd43ff5.png";